import React, { useContext, useState, useEffect } from "react";
import PageLayout from "../../../layouts/PageLayout";
import { Row, Col, Form, Button, Container } from "react-bootstrap";
import { TranslatorContext } from "../../../context/Translator";
import { Link } from "react-router-dom";
import axios from "axios";

export default function DashboardPage() {
  const { t } = useContext(TranslatorContext);
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({
    purchases: 0,
    sales: 0,
    totalAppointments: 0,
    products: 0,
    appointmentsTotalAmount: 0,
    appointmentsPaidAmount: 0,
    appointmentsUnpaidAmount: 0,
    reminderVaccine: [],
    reminderDeworming: [],
    reminderGrooming: [],
    reminderRadiology: []
  });

  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const [filters, setFilters] = useState({
    start_date: "",
    end_date: ""
  });

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = user?.role === "admin";

  useEffect(() => {
    const todayFilters = {
      start_date: getTodayDate(),
      end_date: getTodayDate()
    };

    setFilters(todayFilters);
    fetchDashboardData(todayFilters);
  }, []);

  const fetchDashboardData = async (filterParams = {}) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filterParams.start_date) params.append('start_date', filterParams.start_date);
      if (filterParams.end_date) params.append('end_date', filterParams.end_date);

      const url = `${process.env.REACT_APP_API_URL}/dashboard${params.toString() ? `?${params.toString()}` : ''}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      });

      if (response.data.success) {
        setDashboardData(response.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    fetchDashboardData(filters);
  };

  const resetFilters = () => {
    const today = getTodayDate();
    const resetData = {
      start_date: today,
      end_date: today
    };

    setFilters(resetData);
    fetchDashboardData(resetData);
  };

  if (loading) {
    return (
      <PageLayout>
        <div style={{ textAlign: "center", padding: "50px" }}>
          <div className="spinner"></div>
          <p>Loading Dashboard...</p>
        </div>
      </PageLayout>
    );
  }

  const progressPercent = dashboardData.appointmentsTotalAmount > 0
    ? (dashboardData.appointmentsPaidAmount / dashboardData.appointmentsTotalAmount) * 100
    : 0;

  // limit between 0 - 100
  const safePercent = Math.min(Math.max(progressPercent, 0), 100);


  return (
    <PageLayout>
      <Container fluid className="px-0">
        <Row>
          <Col xl={12}>
            <div className="mc-card">
              <div className="mc-breadcrumb">
                <h3 className="mc-breadcrumb-title">
                  {t("dashboard") || "Dashboard"}
                </h3>
                <ul className="mc-breadcrumb-list">
                  <li className="mc-breadcrumb-item">
                    <Link to="#" className="mc-breadcrumb-link">
                      {t("home") || "Home"}
                    </Link>
                  </li>
                  <li className="mc-breadcrumb-item">
                    {t("dashboard") || "Dashboard"}
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>

        {/* Filter Section */}
        <Row className="mb-4">
          <Col xs={12}>
            <div className="filter-card">
              <div className="filter-header">
                <i className="material-icons">filter_alt</i>
                <h5>Filter Dashboard</h5>
              </div>
              <Row className="align-items-end">
                <Col xs={12} md={5} lg={4} className="mb-3 mb-md-0">
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="start_date"
                      value={filters.start_date}
                      onChange={handleFilterChange}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={5} lg={4} className="mb-3 mb-md-0">
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="end_date"
                      value={filters.end_date}
                      onChange={handleFilterChange}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <div className="filter-buttons">
                    <Button onClick={applyFilters} className="btn btn-primary me-2">
                      <i className="material-icons">search</i> Apply
                    </Button>
                    <Button variant="secondary" onClick={resetFilters}>
                      <i className="material-icons">refresh</i> Reset
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        {isAdmin && (
          <>
            {/* Stats Cards */}
            <Row>
              <Col xs={12} sm={6} xl={6} className="mb-3">
                <div className="stat-card">
                  <div className="stat-icon bg-success">
                    <i className="material-icons">point_of_sale</i>
                  </div>
                  <Link
                    to="/report/daily-closing-report"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div className="stat-content">
                      <h3>{dashboardData.sales}</h3>
                      <p>Total Sales</p>
                    </div>
                  </Link>

                </div>
              </Col>

              <Col xs={12} sm={6} xl={6} className="mb-3">

                <div className="stat-card">
                  <div className="stat-icon bg-info">
                    <i className="material-icons">calendar_today</i>
                  </div>
                  <Link
                    to="/report/daily-closing-report"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div className="stat-content">
                      <h3>{dashboardData.totalAppointments}</h3>
                      <p>Appointments</p>
                    </div>
                  </Link>
                </div>
              </Col>
            </Row>


          </>
        )}

        {/* Reminders Tables */}
        <Row>
          {/* Vaccine Reminders Table */}
          <Col xs={12} xl={6} className="mb-4">
            <div className="mc-card h-100">
              <h4 className="card-title">
                💉 Vaccine Reminders
                {dashboardData.reminderVaccine.length > 0 && (
                  <span className="table-badge">{dashboardData.reminderVaccine.length}</span>
                )}
              </h4>
              {dashboardData.reminderVaccine.length > 0 ? (
                <div className="table-responsive">
                  <table className="simple-table">
                    <thead>
                      <tr>
                        <th>Pet Name</th>
                        <th>Owner</th>
                        <th>Vaccine</th>
                        <th>Reminder Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardData.reminderVaccine.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <strong>{item.pet?.name}</strong>
                            <br />
                            <small className="text-muted">{item.pet?.breed_id ? `Breed ID: ${item.pet.breed_id}` : ''}</small>
                          </td>
                          <td>{item.appointment?.customer?.name}</td>
                          <td>{item.vaccine?.product?.name}</td>
                          <td>
                            {new Date(item.reminder_date).toLocaleDateString()}
                            <br />
                            <small className="text-muted">
                              {new Date(item.reminder_date).toLocaleTimeString()}
                            </small>
                          </td>
                          <td>
                            <span className="status-badge pending">Pending</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="empty-state">
                  <i className="material-icons">notifications_none</i>
                  <p>No vaccine reminders found</p>
                </div>
              )}
            </div>
          </Col>

          {/* Deworming Reminders Table */}
          <Col xs={12} xl={6} className="mb-4">
            <div className="mc-card h-100">
              <h4 className="card-title">
                🐛 Deworming Reminders
                {dashboardData.reminderDeworming.length > 0 && (
                  <span className="table-badge">{dashboardData.reminderDeworming.length}</span>
                )}
              </h4>
              {dashboardData.reminderDeworming.length > 0 ? (
                <div className="table-responsive">
                  <table className="simple-table">
                    <thead>
                      <tr>
                        <th>Pet Name</th>
                        <th>Owner</th>
                        <th>Product</th>
                        <th>Reminder Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardData.reminderDeworming.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <strong>{item.pet?.name}</strong>
                            <br />
                            <small className="text-muted">{item.pet?.breed_id ? `Breed ID: ${item.pet.breed_id}` : ''}</small>
                          </td>
                          <td>{item.appointment?.customer?.name}</td>
                          <td>{item.deworming?.product?.name}</td>
                          <td>
                            {new Date(item.reminder_date).toLocaleDateString()}
                            <br />
                            <small className="text-muted">
                              {new Date(item.reminder_date).toLocaleTimeString()}
                            </small>
                          </td>
                          <td>
                            <span className="status-badge pending">Pending</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="empty-state">
                  <i className="material-icons">notifications_none</i>
                  <p>No deworming reminders found</p>
                </div>
              )}
            </div>
          </Col>

          {/* Grooming Reminders Table */}
          <Col xs={12} xl={6} className="mb-4">
            <div className="mc-card h-100">
              <h4 className="card-title">
                ✂️ Grooming Reminders
                {dashboardData.reminderGrooming.length > 0 && (
                  <span className="table-badge">{dashboardData.reminderGrooming.length}</span>
                )}
              </h4>
              {dashboardData.reminderGrooming.length > 0 ? (
                <div className="table-responsive">
                  <table className="simple-table">
                    <thead>
                      <tr>
                        <th>Pet Name</th>
                        <th>Owner</th>
                        <th>Service</th>
                        <th>Reminder Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardData.reminderGrooming.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <strong>{item.pet?.name}</strong>
                            <br />
                            <small className="text-muted">{item.pet?.breed_id ? `Breed ID: ${item.pet.breed_id}` : ''}</small>
                          </td>
                          <td>{item.appointment?.customer?.name}</td>
                          <td>{item.grooming?.name}</td>
                          <td>
                            {new Date(item.reminder_date).toLocaleDateString()}
                            <br />
                            <small className="text-muted">
                              {new Date(item.reminder_date).toLocaleTimeString()}
                            </small>
                          </td>
                          <td>
                            <span className="status-badge pending">Pending</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="empty-state">
                  <i className="material-icons">notifications_none</i>
                  <p>No grooming reminders found</p>
                </div>
              )}
            </div>
          </Col>

          {/* Radiology Reminders Table */}
          <Col xs={12} xl={6} className="mb-4">
            <div className="mc-card h-100">
              <h4 className="card-title">
                📷 Radiology Reminders
                {dashboardData.reminderRadiology.length > 0 && (
                  <span className="table-badge">{dashboardData.reminderRadiology.length}</span>
                )}
              </h4>
              {dashboardData.reminderRadiology.length > 0 ? (
                <div className="table-responsive">
                  <table className="simple-table">
                    <thead>
                      <tr>
                        <th>Pet Name</th>
                        <th>Owner</th>
                        <th>Service</th>
                        <th>Reminder Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardData.reminderRadiology.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <strong>{item.pet?.name}</strong>
                            <br />
                            <small className="text-muted">{item.pet?.breed_id ? `Breed ID: ${item.pet.breed_id}` : ''}</small>
                          </td>
                          <td>{item.appointment?.customer?.name}</td>
                          <td>{item.radiology?.name}</td>
                          <td>
                            {new Date(item.reminder_date).toLocaleDateString()}
                            <br />
                            <small className="text-muted">
                              {new Date(item.reminder_date).toLocaleTimeString()}
                            </small>
                          </td>
                          <td>
                            <span className="status-badge pending">Pending</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="empty-state">
                  <i className="material-icons">notifications_none</i>
                  <p>No radiology reminders found</p>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <style>{`
        
      `}</style>
    </PageLayout>
  );
}